import React from 'react'
import PropTypes from 'prop-types'
import AvatarWrapper from 'ui/partials/AvatarWrapper'
import * as Displays from 'support/displays/index'

export function Avatar (props) {
  return (
    <AvatarWrapper>
      <Displays.Image name={props.name}/>
    </AvatarWrapper>
  )
}

Avatar.defaultProps = {}

Avatar.propTypes = {
  name: PropTypes.string,
}

export default Avatar
